export default __webpack_public_path__ + "static/media/IBimageAnklestiffness1.3c5c5598.png";